import { AuditResults } from '~/models/audit-model';
import { FetchUtils } from '~/utils/fetch-utils';

export class AuditApi {
	public static getAudit(
		functionName: string,
		recordId: number,
		queryParams?: Map<string, string>,
	): Promise<AuditResults> {
		const queryParamsAsObj: { [fieldName: string]: string } = {};
		if (queryParams) {
			queryParams.forEach((value, key) => {
				queryParamsAsObj[key] = value;
			});
		}
		return FetchUtils.getJSON<AuditResults>(
			'api/:functionName/:recordId/audit',
			{
				...queryParamsAsObj,
				functionName,
				recordId,
			},
		);
	}

	public static getAddressAudit(
		functionName: string,
		recordId: number,
		queryParams?: Map<string, string>,
	): Promise<AuditResults> {
		const queryParamsAsObj: { [fieldName: string]: string } = {};
		if (queryParams) {
			queryParams.forEach((value, key) => {
				queryParamsAsObj[key] = value;
			});
		}
		return FetchUtils.getJSON<AuditResults>(
			'api/:functionName/:recordId/address-audit',
			{
				...queryParamsAsObj,
				functionName,
				recordId,
			},
		);
	}

	public static getFormAudit(
		functionName: string,
		queryString?: string,
	): Promise<AuditResults> {
		return FetchUtils.getJSON<AuditResults>(
			'api/:functionName/form/audit?' + queryString,
			{
				functionName,
			},
			{
				extractParamsFromURL: true,
			},
		);
	}
}
